import { TOAST_VARIANT_SUCCESS, toastShow } from 'mailup-web-components'

import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import getIntl from 'Helpers/intl'

import {
  beRecipientCopyMoveRecipientsToGroupByCustomSearch,
  beRecipientCopyMoveRecipientsToGroupByManualSelection,
  beRecipientGetGroupDetails,
  beRecipientUpdateGroup,
} from 'Api/beRecipientApi'

import {
  searchFiltersToConditions,
  toSubscriptionStatus,
} from 'Pages/RecipientsList/recoil/services/results'

import type {
  ModalBulkRemoveFromGroupsState,
  SearchFiltersState,
  SelectionState,
} from 'Pages/RecipientsList/model'

export const notifyBulkRemoveFromGroups = (move: boolean): void => {
  toastShow(
    getIntl().formatMessage({
      id: move
        ? 'Load.RecipientsList.BulkMoveToGroupSuccess'
        : 'Load.RecipientsList.BulkRemoveFromGroupsSuccess',
    }),
    TOAST_VARIANT_SUCCESS,
  )
}

export const removeFromGroups = async (
  {
    mode,
    checked,
    searchFilters,
  }: {
    mode: SelectionState['mode']
    checked: SelectionState['checked']
    searchFilters: SearchFiltersState
  },
  {
    addToGroupId,
    optAddToGroup,
    removeFromGroupsMode,
    optMoveRandom,
    moveRandomAmount,
    optSetAsTestGroup,
    searchGroups,
  }: Pick<
    ModalBulkRemoveFromGroupsState,
    | 'addToGroupId'
    | 'optAddToGroup'
    | 'removeFromGroupsMode'
    | 'optMoveRandom'
    | 'moveRandomAmount'
    | 'optSetAsTestGroup'
    | 'searchGroups'
  >,
): Promise<void> => {
  if (mode === 'selection' && checked.length === 0) {
    return
  }
  //
  const idList = storeGet(STORE_KEY_ID_LIST)

  const moveRandomN = moveRandomAmount !== undefined ? moveRandomAmount : 0

  const idGroup = optAddToGroup && addToGroupId !== undefined ? addToGroupId : 0

  if (mode === 'selection' && checked.length > 0) {
    await beRecipientCopyMoveRecipientsToGroupByManualSelection(
      idList,
      idGroup,
      checked,
      true,
      optMoveRandom,
      moveRandomN,
      removeFromGroupsMode === 'all' ? [] : searchGroups,
    )
  } else {
    await beRecipientCopyMoveRecipientsToGroupByCustomSearch(idList, idGroup, {
      Conditions: searchFiltersToConditions(searchFilters),
      SubscriptionStatus: toSubscriptionStatus(searchFilters.status.value),
      MoveRecipients: true,
      RandomSelectRecipients: optMoveRandom,
      RecipientToSelectRandom: moveRandomN,
      MoveFromGroups: removeFromGroupsMode === 'all' ? [] : searchGroups,
    })
  }

  if (optAddToGroup && optSetAsTestGroup && idGroup > 0) {
    const { Id, ...groupDetails } = await beRecipientGetGroupDetails(idGroup)

    await beRecipientUpdateGroup(Id, {
      ...groupDetails,
      Type: 'Test',
    })
  }
  //
}
